export default "__VITE_ASSET__BFlyIj7z__"